import React from 'react';
import { motion } from 'framer-motion';
import { LayersIcon } from 'lucide-react';
export function BonusSection() {
  const bonuses = [{
    icon: '🥗',
    text: 'Alimentación y rendimiento'
  }, {
    icon: '💪',
    text: 'Kegel avanzado profundo'
  }, {
    icon: '🔥',
    text: 'Presencia en intimidad'
  }, {
    icon: '🧠',
    text: 'Reset de estímulo (porno + dopamina)'
  }, {
    icon: '📅',
    text: 'Plan de acción 14 días'
  }, {
    icon: '🎧',
    text: 'Audios hipnóticos de reprogramación'
  }];
  return <section className="relative w-full bg-[#0a0a0a] py-10 md:py-14 overflow-hidden" data-id="element-14">
      <div className="absolute inset-0 z-0" data-id="element-15">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[400px] rounded-full bg-red-900/12 blur-[120px]" data-id="element-16" />
      </div>

      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-64 h-px bg-gradient-to-r from-transparent via-red-600 to-transparent z-20" data-id="element-17" />

      <div className="relative z-20 max-w-4xl mx-auto px-6" data-id="element-18">
        <motion.div initial={{
        opacity: 0,
        y: 15
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="relative bg-gradient-to-b from-[#0a0a0a] to-black border border-red-900/50 rounded-2xl p-6 md:p-10 shadow-[0_0_50px_rgba(220,38,38,0.12)] overflow-hidden" data-id="element-19">
          {/* Corner accents */}
          <span className="absolute top-0 left-0 w-6 h-6 border-t-2 border-l-2 border-red-600" data-id="element-20" />
          <span className="absolute top-0 right-0 w-6 h-6 border-t-2 border-r-2 border-red-600" data-id="element-21" />
          <span className="absolute bottom-0 left-0 w-6 h-6 border-b-2 border-l-2 border-red-600" data-id="element-22" />
          <span className="absolute bottom-0 right-0 w-6 h-6 border-b-2 border-r-2 border-red-600" data-id="element-23" />

          <div className="absolute inset-0 bg-red-600/5 blur-3xl" data-id="element-24" />

          {/* Header */}
          <div className="relative text-center mb-8" data-id="element-25">
            <div className="inline-flex items-center gap-2 bg-red-900/30 border border-red-600/50 text-red-400 px-4 py-1.5 rounded-full text-xs font-bold uppercase tracking-widest mb-4 shadow-[0_0_15px_rgba(220,38,38,0.2)]" data-id="element-26">
              <LayersIcon className="w-4 h-4" data-id="element-27" />
              Material complementario
            </div>
            <h2 className="font-display text-2xl md:text-4xl uppercase text-white drop-shadow-[0_0_20px_rgba(220,38,38,0.3)] leading-tight" data-id="element-28">
              Y además incluye{' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-b from-red-400 to-red-600" data-id="element-29">
                6 módulos extra
              </span>
            </h2>
            <p className="text-gray-400 text-sm md:text-base mt-2" data-id="element-30">
              Recursos prácticos para potenciar y acelerar tus resultados.
            </p>
          </div>

          {/* Two-column compact list */}
          <div className="relative grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-3" data-id="element-31">
            {bonuses.map((bonus, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -10
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.06,
            duration: 0.4
          }} className="flex items-center gap-3 py-2 border-b border-red-900/20" data-id="element-32">
                <span className="text-lg flex-shrink-0" data-id="element-33">{bonus.icon}</span>
                <span className="text-sm md:text-base text-white font-medium flex-grow" data-id="element-34">
                  {bonus.text}
                </span>
                <span className="text-xs text-green-400 font-bold uppercase tracking-wider flex-shrink-0" data-id="element-35">
                  Incluido
                </span>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}